import React from 'react';
import { useMapEvents } from 'react-leaflet';

/**
 * Component that forces a Leaflet map to invalidate its size after mounting
 * This fixes the common issue where parts of the map don't load initially
 */
const MapResizer = () => {
  // Always call hooks unconditionally at the top level
  const map = useMapEvents({
    load: () => {
      // Only run the effect if we're in a browser environment
      if (typeof window !== 'undefined') {
        setTimeout(() => {
          map.invalidateSize();
        }, 100);
      }
    },
  });
  
  return null;
};

export default MapResizer; 